/**
 * Chevron-down icon. Uses `currentColor` for stroke so it inherits the
 * parent element's text color automatically.
 *
 * @param {object} [props]           - Forwarded to the <svg> element.
 * @param {string} [props.className]
 * @param {string|number} [props.width='1em']
 * @param {string|number} [props.height='1em']
 */
export function ChevronDown({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  )
}
